import { GenericNoSubHeaderPage, GenericPage } from "../../../../../pages";

import { catalogueRoutes } from "./control-catalogue.route";
import { sponsorsRoutes } from "./control-sponsors.route";
import { userRoutes } from "./control-user.route";
import { controlEventsRoutes } from "./control-events.route";
import { controlEventReportsRoutes } from "./control-event-reports.route";
import { controlCalendarRoutes } from "./control-calendar.route";
import { controlEventTemplatesRoutes } from "./control-event-templates.route";

export const controlRoutes = [
  {
    path: "events",
    element: <GenericPage />,
    children: controlEventsRoutes,
  },
  {
    path: "reports",
    element: <GenericPage />,
    children: controlEventReportsRoutes,
  },
  {
    path: "calendar",
    element: <GenericPage />,
    children: controlCalendarRoutes,
  },
  {
    path: "catalogues",
    element: <GenericPage />,
    children: catalogueRoutes,
  },
  {
    path: "sponsors",
    element: <GenericPage />,
    children: sponsorsRoutes,
  },
  {
    path: "event-templates",
    element: <GenericPage />,
    children: controlEventTemplatesRoutes,
  },
  {
    path: "users",
    element: <GenericPage />,
    children: userRoutes,
  },
];
